<template>
  <label>
      <input
        :id=inputId
        class="cursor-pointer"
        style="display: none"
        type="file" accept=".svg" @change="loadTextFromFile">
      <label
        :for=inputId
        class="cursor-pointer"
        >
        {{ text }}
      </label>
  </label>
</template>

<script>
let instanceNo = 0;

const DEFAULT_TEXT = "Load an SVG";

export default {
  beforeCreate() {
    this.inputId = `fileInput${instanceNo}`;
    instanceNo++;
  },
  data() {
    return {
      text: DEFAULT_TEXT
    }
  },
  methods: {
    loadTextFromFile(event) {
      this.$emit("loading");
      const file = event.target.files[0];
      this.text = file.name;
      const reader = new FileReader();
      reader.onload = e => {
        this.$emit("load", e.target.result);
        this.text = DEFAULT_TEXT;
      };
      reader.readAsText(file);
    }
  }
};
</script>